import { authHeader, getAuthHeadersWithBearer } from '@discover-frontend/auth';

export default authHeader;

export { getAuthHeadersWithBearer };

/** Auth headers with raw token only (no "Bearer " prefix). Use for APIs that expect token as-is. */
export const getAuthHeadersWithTokenOnly = authHeader;
